import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
       color:"white",
       fontSize:"14px",
       backgroundColor:"black",
       padding:"10px",
       borderRadius:"8px"
      }
    },
  }));

const TextArea=({value,readOnly})=>{
    const classes = useStyles();

    return (
        <TextField
        className={classes.root}
        multiline
        fullWidth
        rows={6}
        value={value}
        inputProps={
            { readOnly: readOnly }
        }
      />
    )
}


export default TextArea;